import React, { useState, useEffect } from 'react';
import '../../style/NavigationPage.css';
import { groupBy } from '../../utils/common';
import { COS_URL } from '../../const/constants.js';
import Header from '../layout/Header/index.jsx';
import { Tooltip } from 'tdesign-react';


const NavigationPage = ({ navList, onChangeAction }) => {
  const [menuList, setMenuList] = useState([]);
  
  useEffect(() => {
    handleSetMenuList(navList);
  }, [navList])

  const handleSetMenuList = (menu) => {
    if (menu.length > 0) {
      const _menu = groupBy(menu, 'row', {
        sort: 'asc'
      });
      setMenuList(_menu);
    } else {
      // TODO: 跳转到错误页面 or 用默认配置
      return []
    }
  }


  return (
    <div className="navigation-container">
      <Header />
      <div className="menu_content">
        <div className="center-container">
          <div className="welcom_container">
            <div className="welcom_title">
              <img className="menuTitle__icon" src={COS_URL + '/icon/star.png'} />
              <div>test欢迎来到</div>
              <div className="menuTitle__name">文字识别 OCR </div>
              <div>体验中心 </div>
            </div>

          </div>

          <div className="menu_container">
            {
              menuList.map((row, rowIndex) => (<div key={`row-${rowIndex}`} className="menu_row">
                {
                  row.map((menu, menuIndex) => (<div key={menu.title || `menu-${menuIndex}`} className="menu_detail__container">
                    <div className="menuTitle_container">
                      <img className="menuTitle__icon" src={COS_URL + menu.icon} />
                      <div className="menuTitle__text">{menu.title}</div>
                      {
                        menu.des && <Tooltip
                        content={menu.des}
                        destroyOnClose
                        showArrow
                        theme="light"
                      >
                        <div className="menuTitle__tips"></div>
                      </Tooltip>
                      }
                      
                    </div>
                    {
                      menu.children.map((menuItem) => (<div key={menuItem.action || menuItem.title} className="menuItem_container">
                        <div className="menuItem_text" onClick={() => {
                          onChangeAction(menuItem.action)
                        }}>{menuItem.title}</div>
                        {
                          menuItem.Tag?.includes('New') && <div className="tag-new"></div>
                        }
                        {
                          menuItem.Tag?.includes('Hot') && <div className="tag-hot"></div>
                        }
                      </div>))
                    }

                  </div>))
                }
              </div >))
            }
          </div>
        </div>
      </div>


    </div>
  );
};

export default NavigationPage;